import * as React from "react";
import './Number.css';
import {uniqueId} from "../../config/Tools";
import useTranslation from "../../hooks/useTranslation";

const inputMainProps = ['required', 'name', 'value', 'onChange', 'placeholder', 'onKeyPress', 'min', 'max'];

function Number(props) {
    const {t} = useTranslation();

    const getMainProps = (elementProps) => {
        const result = {};
        Object.entries(props).forEach(([propName, value]) => {
            (elementProps.indexOf(propName) !== -1) && (result[propName] = value);
        });
        return result;
    }

    const handleChange = e => {
        props.onChange(e.target.name, parseFloat(e.target.value));
    }

    const disabled = props.disabled || false;

    let className = `FormInput`;
    props.className && (className = `${className} ${props.className}`);
    props.required && (className += " required");
    props.disabled && (className += " disabled");
    const id = uniqueId();
    return (
        <div className={className}>
            {props.label !== false && <label htmlFor={id}>{props.label || t(props.name)}</label>}
            <input type="number" {...getMainProps(inputMainProps)} onChange={handleChange} disabled={disabled}/>
        </div>
    );
}

export default Number;